<template>
	<div class="pos-rel">
		<video
			id="player"
			width="100%"
			:height="isFullView ? 'auto' : 200"
			controls
		>
			<source id="source" :src="src" type="video/mp4" />
			Your browser does not support the video tag.
		</video>
	</div>
</template>

<script>
export default {
	name: "AnalyticsElVideo",
	props: ["src", "isFullView"],
	methods: {
		// _getVidMimeType(obj) {
		// 	return typeof obj === "object" ? obj.S : "video/mp4"
		// },
	},
	updated() {
		// HTML5 video tag attribute change issue fix
		const video_el = document.getElementById("player")
		const source_el = document.getElementById("source")
		video_el.pause()
		source_el.src = this.src
		video_el.load()
	}
}
</script>
